import { ReviewStatus } from "@redotech/redo-model/review/review";
import { ReviewFieldDbParser } from "@redotech/redo-model/review/review-db-parser";
import { z } from "zod";

export const upsertReview = {
  input: z.object({
    status: z.enum(ReviewStatus),
    shopifyProductId: z.string(),
    customer: z.optional(z.object({ email: z.string() })),
    reviewFields: z.array(ReviewFieldDbParser),
    existingReviewId: z.string().optional(),
  }),
  output: z.object({ reviewId: z.string() }),
};
